import { render, staticRenderFns } from "./itemsCard.vue?vue&type=template&id=ff287afa&"
import script from "./itemsCard.vue?vue&type=script&lang=js&"
export * from "./itemsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports